module.exports = __webpack_public_path__ + "static/media/26UNRWA10.116c1d62.jpg";